import { MainBackground } from "components/UI/Icons";
import { MainViews } from "components/Views/MainViews";
import "styles/index.scss";
import styles from "./App.module.scss";

export const App = () => {
  return (
    <div className={styles.app}>
      <MainBackground className={styles.background} />
      <MainViews />
    </div>
  );
};
